import AdminCanjeDetail from "./AdminCanjeDetail.container";
import container from "./container";

export default container(AdminCanjeDetail);
